<template>
    <!-- 下拉选择导入或导出 -->
    <div v-if="roles[0] || roles[1]" class="FileDropDown">
        <input type="file" ref="uploadFile" :accept="accept" @change="uploadFileChange" v-show="1 != 1">
        <input type="file" ref="zipUploadFile" accept=".zip" @change="uploadFileChange" v-show="1 != 1">
        <el-dropdown @command="importFile">
            <el-button size="medium" type="primary">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <template v-for="(item, index) in butText">
                    <el-dropdown-item v-if="roles[index]" :command="index">{{ butText[index] }}</el-dropdown-item>
                </template>
                <!-- <el-dropdown-item v-if="roles[1]" command="2">{{ butText[1] }}</el-dropdown-item>
                <el-dropdown-item v-if="roles[2]" command="3">{{ butText[2] }}</el-dropdown-item> -->
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>
  
<script>
import {
    exportFile
} from "@/uitls/globalFun.js";

export default {
    name: 'FileDropDown',
    props: {
        isZip: {
            type: Boolean,
            default: false
        },
        // 默认只允许上传.xls格式文件
        accept: {
            type: String,
            default: '.xls,.xlsx'
        },
        // 上传地址
        toUrl: {
            type: Array,
        },
        exportData: {
            type: Object,
        },
        theWay: {
            type: Array,
            default: () => {
                return [1, 2]
            }
        },
        // 下载地址
        downloadUrl: {
            type: String,
        },
        //导出地址
        exportUrl: {
            type: String,
        },
        // 权限
        roles: {
            type: Array,
            default: () => {
                return [true, true, true];
            }
        },
        // 下拉按钮文字
        butText: {
            type: Array,
            default: () => {
                return ['下载模板', '导入考点'];
            }
        }
    },
    data() {
        return {
            operaNum: null
        }
    },
    methods: {
        // 下拉选中
        importFile(type) {
            console.log(777, type, this.theWay[type]);
            if (this.theWay[type] == 1) {
                this.$axios
                    .get(this.toUrl[type], {
                        responseType: "blob"
                    })
                    .then((res) => {
                        exportFile(res);
                    });
            } else if (this.theWay[type] == 2) {
                this.operaNum = type
                if(type==2&&this.isZip==true){
                    this.$refs.zipUploadFile.click()
                }else{
                    this.$refs.uploadFile.click()
                }
            }
            else if (this.theWay[type] == 3) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios
                    .post(this.toUrl[type], this.exportData, {
                        responseType: "blob"
                    })
                    .then((res) => {
                        exportFile(res);
                        loading.close();
                    });
            }
        },
        // 弹出文件选择
        click() {
            this.$refs.uploadFile.click();
        },
        // 文件选中上传
        uploadFileChange(e) {
            const loading = this.$loading({
                lock: true,
                text: '正在导入',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let file = e.target.files[0];
            let formData = new FormData();
            formData.append('file', file)
            e.outerHTML = e.outerHTML; //可清空当前file之前添加的文件
            e.target.value = "";
            this.$axios
                .post(this.toUrl[this.operaNum], formData)
                .then((res) => {
                    this.$message({
                        type: "success",
                        message: "导入成功！", duration: 1000
                    });
                    loading.close();
                    this.$emit('reLoad')
                }).catch(err => {
                    loading.close();
                    this.$emit('reLoad')
                })

        }
    }
}
</script>
  